import React, { useState } from "react";

import { Button, Stack, Typography } from "@mui/material";

import ReviewAdDialog, { ReviewAdDialogType } from "./ReviewAdDialog";

export interface ReviewAdCardProps {
  obituaryId: number;
  refresh: () => void;
  type: ReviewAdDialogType;
}

const ReviewAdCard: React.FC<ReviewAdCardProps> = ({
  obituaryId,
  refresh,
  type,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const title = "Orden behöver granskas";
  const subtitle = "Du kan godkänna eller refusera ordern.";

  return (
    <>
      <Stack
        alignItems="center"
        bgcolor="#BBDEFB"
        border="1px solid #1876D2"
        borderRadius="12px"
        direction="row"
        gap={2}
        justifyContent="space-between"
        p={3}
      >
        <Stack flex={1}>
          <Typography color="#1876D2" fontWeight={500} variant="body1">
            {title}
          </Typography>
          <Typography color="#1876D2" variant="body2">
            {subtitle}
          </Typography>
        </Stack>
        <Button
          sx={{
            bgcolor: "#1876D2",
            "&:hover": {
              bgcolor: "#2952A3",
            },
          }}
          variant="contained"
          onClick={() => setIsDialogOpen(true)}
        >
          Granska
        </Button>
      </Stack>

      <ReviewAdDialog
        obituaryId={obituaryId}
        open={isDialogOpen}
        refresh={refresh}
        setOpen={setIsDialogOpen}
        type={type}
      />
    </>
  );
};

export default ReviewAdCard;
